import { DataTable } from "@/shared/components/DataTable/DataTable";

import { INVOICE_COLUMN_ALIGN_CLASS } from "../constants/invoiceLineColumns";
import type { InvoiceLineColumn, InvoiceLineItem } from "../types";

type InvoiceLineTableProps = {
  columns: InvoiceLineColumn[];
  rows: InvoiceLineItem[];
  emptyText?: string;
  staticHeight?: number;
};

export default function InvoiceLineTable({
  columns,
  rows,
  emptyText = "No lines to show",
  staticHeight = 40,
}: InvoiceLineTableProps) {
  const headers = columns.map((column) =>
    column.align && column.align !== "left" ? (
      <span key={column.key} className={`w-full ${INVOICE_COLUMN_ALIGN_CLASS[column.align].cell}`}>
        {column.label}
      </span>
    ) : (
      column.label
    )
  );

  const renderRow = (row: InvoiceLineItem) =>
    columns.map((column) => (
      <td
        key={column.key}
        className={`px-4 py-3 ${INVOICE_COLUMN_ALIGN_CLASS[column.align || "left"].cell} ${
          column.cellClassName || ""
        }`}
      >
        {column.render(row)}
      </td>
    ));

  return (
    <DataTable
      headers={headers}
      headerKeys={columns.map((column) => column.key)}
      rows={rows}
      renderRow={renderRow}
      emptyText={emptyText}
      showSearch={false}
      syncUrl={false}
      isPagination={false}
      staticHeight={staticHeight}
    />
  );
}
